import { useHistory } from 'react-router-dom'

import { finishRoute } from 'modules/contribution/helpers'
import DigitalWalletButton from 'modules/contribution/components/DigitalWalletButton'
import { DigitalWalletType } from 'modules/contribution/types'

import digitalWalletImg from 'static/img/digital-wallet.svg'
import styles from './GiftingDigitalWalletView.module.scss'
import { useState } from 'react'
import { WarnMesssage } from '@collegebacker/backer-ui/ui'

const GiftingDigitalWalletView = ({
  feeForDigitalWallet,
  feeForDigitalWalletLoading,
  digitalWalletType,
  fund,
  user
}: {
  feeForDigitalWallet: number
  digitalWalletType: DigitalWalletType
  feeForDigitalWalletLoading: boolean
  fund: any
  user: any
}) => {
  const history = useHistory()
  const [error, setError] = useState('')

  return (
    <div className={styles.container}>
      {error && <WarnMesssage text={error} type="warning"/>}
      <div className={styles.textContainer}>
        <img src={digitalWalletImg} alt="" />
        <p className={styles.text}>
          Easiest way to make a contribution.
        </p>
      </div>
      <div className={styles.btnContainer}>
        <DigitalWalletButton
          subscriptionFee={feeForDigitalWallet}
          type={digitalWalletType}
          fund={fund}
          user={user}
          disabled={feeForDigitalWalletLoading}
          onSuccess={(paymentIntent: { id: string, payment_method: string }, contributionDraft: any) => {
            const { id, payment_method } = paymentIntent
            history.replace(
              finishRoute('gift', contributionDraft, fund, {
                paymentIntentId: id,
                paymentMethodId: payment_method,
              }),
            )
          }}
          onFailure={setError}
        />
      </div>
    </div>
  )

}

export default GiftingDigitalWalletView